import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Box } from "../../../model/box";
@Component({
  selector: 'aw-add-researchers-dialog',
  templateUrl: './add-researchers-dialog.component.html',
  styleUrls: ['./add-researchers-dialog.component.scss']
})
export class AddResearchersDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Box,
    public dialogRef: MatDialogRef<AddResearchersDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


